var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80606 18.8404C1.4234 11.0982 0.464844 10.2871 0.464844 7.41147C0.464844 3.50351 3.59858 0.332904 7.54341 0.332904C11.4514 0.332904 14.622 3.50351 14.622 7.41147C14.622 10.2871 13.6265 11.0982 8.24389 18.8404C7.91208 19.3565 7.13786 19.3565 6.80606 18.8404ZM7.54341 10.3609C9.16558 10.3609 10.4928 9.0705 10.4928 7.41147C10.4928 5.7893 9.16558 4.46206 7.54341 4.46206C5.88437 4.46206 4.594 5.7893 4.594 7.41147C4.594 9.0705 5.88437 10.3609 7.54341 10.3609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.37ab1d7abc280ba9f81ff0bfd2edf728.svg";
export { ForwardRef as ReactComponent };